wbApp.controller('RentCategoriesDetailCtrl', ['$scope', '$modal', 'rentCategorySvc',
function ($scope, $modal, rentCategorySvc) {

    function extendModel(model) {

        if (!(model.pickupTimeFrom == null)) {
            model.date_pickupTimeFrom = moment().startOf('day').add(model.pickupTimeFrom, 'm').toDate();
        }
        if (!(model.pickupTimeTo == null)) {
            model.date_pickupTimeTo = moment().startOf('day').add(model.pickupTimeTo, 'm').toDate();
        }
        if (!(model.returnTimeFrom == null)) {
            model.date_returnTimeFrom = moment().startOf('day').add(model.returnTimeFrom, 'm').toDate();
        }
        if (!(model.returnTimeTo == null)) {
            model.date_returnTimeTo = moment().startOf('day').add(model.returnTimeTo, 'm').toDate();
        }
    }

    extendModel($scope.model);

    $scope.modelOrig = angular.copy($scope.model);


    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            rentCategorySvc.insert(data)
                .$promise.then(success, error);
        } else {
            rentCategorySvc.update(data)
                .$promise.then(success, error);
        }

        function success(newModel) {
            $scope.onRentCategorySave(newModel);
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };


    $scope.isFormValid = function() {
        return true;
    }

    $scope.onDeletePictureBtnClick = function (pictureUrl) {
        _.pull($scope.model.pictureUrls || [], pictureUrl);
    }

    $scope.showPictureSelect = function () {
        picturesSelectDlgPromise.$promise.then(function () {
            picturesSelectDlgPromise.$scope.onPicturesSelected = function (pictures) {

                if (!$scope.model.pictureUrls) {
                    $scope.model.pictureUrls = [];
                }

                angular.forEach(pictures, function (p) {
                    if (!_.find($scope.model.pictureUrls, p.imageUrl)) {
                        $scope.model.pictureUrls.push(p.imageUrl);
                    }
                });
            };
            picturesSelectDlgPromise.show();
        });
    }

    var picturesSelectDlgPromise = $modal({
        templateUrl: 'storage/pictures/pictures-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.ondate_pickupTimeFromChange = function (date_pickupTimeFrom) {
        var m = moment(date_pickupTimeFrom);
        if (m.isValid()) {
            $scope.model.pickupTimeFrom = m.hour() * 60 + m.minute();
        } else {
            $scope.model.pickupTimeFrom = 12 * 60; // Default
        }
    }

    $scope.ondate_pickupTimeToChange = function (date_pickupTimeTo) {
        var m = moment(date_pickupTimeTo);
        if (m.isValid()) {
            $scope.model.pickupTimeTo = m.hour() * 60 + m.minute();
        } else {
            $scope.model.pickupTimeTo = 23 * 60 + 59; // Default
        }
    }

    $scope.ondate_returnTimeFromChange = function (date_returnTimeFrom) {
        var m = moment(date_returnTimeFrom);
        if (m.isValid()) {
            $scope.model.returnTimeFrom = m.hour() * 60 + m.minute();
        } else {
            $scope.model.returnTimeFrom = 0; // Default
        }
    }

    $scope.ondate_returnTimeToChange = function (date_returnTimeTo) {
        var m = moment(date_returnTimeTo);
        if (m.isValid()) {
            $scope.model.returnTimeTo = m.hour() * 60 + m.minute();
        } else {
            $scope.model.returnTimeTo = 12 * 60; // Default
        }
    }

    $scope.onrentingPeriodTypeChange = function (rentingPeriodType) {
        if (rentingPeriodType == 0) { // minutes

            $scope.model.pickupTimeFrom = null; // Default
            $scope.model.pickupTimeTo = null; // Default
            $scope.model.returnTimeFrom = null; // Default
            $scope.model.returnTimeTo = null; // Default

            $scope.model.rentingPeriodStepSize = 60;
            $scope.model.minimumRentingPeriods = 60;
            $scope.model.maximumRentingPeriods = 120;

            $scope.model.rentHourStartType = 1;
            
        } else { // days
            $scope.model.pickupTimeFrom = 12 * 60; // Default
            $scope.model.pickupTimeTo = 23 * 60 + 59; // Default
            $scope.model.returnTimeFrom = 0; // Default
            $scope.model.returnTimeTo = 12 * 60; // Default

            $scope.model.rentingPeriodStepSize = 1;
            $scope.model.minimumRentingPeriods = 1;
            $scope.model.maximumRentingPeriods = 14;

            $scope.model.rentHourStartType = 0;
        }
        extendModel($scope.model);
    }

    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "rents/rent-category/rent-category-detail-main-tab.html"
    },
    {
        title: 'TXT_TIME_SETTING',
        template: "rents/rent-category/rent-category-detail-time-setting-tab.html"
    },
    {
        title: 'TXT_LBL_DESCRIPTION',
        template: "rents/rent-category/rent-category-detail-description-tab.html"
    },
    {
        title: 'TXT_LBL_PICTURES',
        template: "rents/rent-category/rent-category-detail-pictures-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;
}]);
